import { styled } from '@grupoboticario/flora-react';

export default {
  ImageContainer: styled('div', {
    width: '100%',
    height: '177px',
    justifyContent: 'center',
    display: 'flex',
    img: {
      width: '177px',
      height: '177px',
    },
  }),
};
